import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMountains = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2 6.73703L10.25 10.667L12.5 13.667C12.83 14.107 12.74 14.737 12.3 15.067C11.86 15.397 11.23 15.317 10.9 14.867C9.84999 13.467 8.58999 11.797 7.79999 10.727C7.39999 10.197 6.59999 10.197 6.19999 10.727L2.19999 16.057C1.70999 16.727 2.17999 17.667 2.99999 17.667H21C21.82 17.667 22.29 16.727 21.8 16.067L14.8 6.73703C14.4 6.19703 13.6 6.19703 13.2 6.73703Z",
		fill: "currentColor"
	})
});
export default SvgMountains;
